import { handleActions } from 'redux-actions';

import { actions } from '../actions/errors';

// Destructure the ErrorActions.
export const {
  errorReconnectAttempt,
  errorReconnectAttemptReset,

  errorConnectionLostShowModal,
  errorConnectionLostHideModal,

  errorMicrophoneErrorShowModal,
  errorMicrophoneErrorHideModal,
  errorWsConnectionChangedShowModal,
} = actions;

type ErrorState = {
  meta: {
    reconnectAttempt: number;
    delay: number;
  };
  ui: {
    connectionLostShowModal: boolean;
    microphoneErrorShowModal: boolean;
    connectionChangedShowModal: boolean;
  };
  microphoneError: any | null;
  errors: Array<any>;
};

// Init state for the Search.
const initialState: ErrorState = {
  meta: {
    reconnectAttempt: 0,
    delay: 0,
  },
  ui: {
    connectionLostShowModal: false,
    microphoneErrorShowModal: false,
    connectionChangedShowModal: false,
  },
  errors: [],
  microphoneError: {
    error: false,
    message: '',
    name: null,
  },
};

function _generateDelay(k = 0) {
  let timeout = Math.round((Math.random() + 1) * (1 * 1000) * Math.pow(1.5, k));
  timeout = Math.min(timeout, Infinity); // Change to a number for a limit in max timeout.
  return timeout;
}

// Reducer
const errors = handleActions<ErrorState, any>(
  {
    // ERROR ACTIONS.
    [errorReconnectAttempt.toString()]: (state: ErrorState, action: any) => {
      let reconnectAttempt = state.meta.reconnectAttempt;

      if (reconnectAttempt < 10) {
        // Stop attempt count at 10.
        reconnectAttempt++;
      }

      const delay = _generateDelay(reconnectAttempt);

      return {
        ...state,
        meta: {
          ...state.meta,
          reconnectAttempt: reconnectAttempt,
          delay: delay,
        },
      };
    },

    [errorReconnectAttemptReset.toString()]: (
      state: ErrorState,
      action: any,
    ) => {
      return {
        ...state,
        meta: { ...state.meta, reconnectAttempt: 0, delay: 0 },
        ui: {
          ...state.ui,
          connectionLostShowModal: false,
          connectionChangedShowModal: false,
        },
      };
    },

    [errorConnectionLostShowModal.toString()]: (
      state: ErrorState,
      action: any,
    ) => {
      return { ...state, ui: { ...state.ui, connectionLostShowModal: true } };
    },

    [errorConnectionLostHideModal.toString()]: (
      state: ErrorState,
      action: any,
    ) => {
      return { ...state, ui: { ...state.ui, connectionLostShowModal: false } };
    },

    [errorMicrophoneErrorShowModal.toString()]: (
      state: ErrorState,
      action: any,
    ) => {
      return {
        ...state,
        ui: { ...state.ui, microphoneErrorShowModal: true },
        microphoneError: action.payload !== undefined ? action.payload : null,
      };
    },

    [errorMicrophoneErrorHideModal.toString()]: (
      state: ErrorState,
      action: any,
    ) => {
      return { ...state, ui: { ...state.ui, microphoneErrorShowModal: false } };
    },

    [errorWsConnectionChangedShowModal.toString()]: (
      state: ErrorState,
      action: any,
    ) => {
      return {
        ...state,
        ui: { ...state.ui, connectionChangedShowModal: true },
      };
    },
  },
  initialState,
);

export default errors;
